import type { ScenarioCalendarBasis } from "@opus-dt/shared-types";

// De onde saiu a jornada que esta simulação usa.
// O rótulo existe porque as horas sozinhas não respondem à pergunta. "12h corridas · 8h
// operacionais" prova que HÁ expediente, mas não diz se ele é o da fábrica (vale para a planta
// inteira), o desta linha, ou uma cópia editada aqui dentro que não corresponde a lugar nenhum. É
// a diferença entre "o resultado é comparável com o indicador da linha" e "não é".
// O regime contínuo é o único com tom de atenção: é o que MAIS afasta a simulação do indicador —
// 24 h por dia contra um expediente real — e é o mais fácil de herdar sem perceber.

export interface CalendarBasisLabel {
  label: string;
  /** Frase completa no `title`/leitor de tela — o rótulo curto cabe na barra, a explicação não. */
  description: string;
  tone: "neutral" | "warning";
}

const LABELS: Record<ScenarioCalendarBasis, CalendarBasisLabel> = {
  organization: {
    label: "Expediente da fábrica",
    description:
      "Esta simulação usa o expediente padrão da fábrica, herdado porque a linha base não declarou o próprio.",
    tone: "neutral",
  },
  line: {
    label: "Expediente da linha",
    description: "Esta simulação usa o expediente próprio da linha base.",
    tone: "neutral",
  },
  scenario: {
    label: "Expediente do cenário",
    description:
      "Esta simulação usa uma cópia de expediente editada dentro do cenário — ela não corresponde a nenhuma linha real.",
    tone: "neutral",
  },
  continuous: {
    label: "Contínuo · 24 h",
    description:
      "Esta simulação roda 24 horas por dia, sem parar em nenhum expediente. Compare com cuidado: o indicador da linha conta só as horas de expediente.",
    tone: "warning",
  },
};

export function calendarBasisLabel(basis: ScenarioCalendarBasis): CalendarBasisLabel {
  return LABELS[basis];
}
